module.exports = __webpack_public_path__ + "img/fiche.926b3dd.PNG";